module.exports = __webpack_public_path__ + "static/img/ltjl.1cbae6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/ltjl.png
// module id = 1245
// module chunks = 0